export var ViewMode;
(function (ViewMode) {
    ViewMode["DEFAULT"] = "default";
    ViewMode["MY_TABLE"] = "my-table";
})(ViewMode || (ViewMode = {}));
